<template>
  <a-cascader @change="changeXzc" :expandTrigger="expandTrigger" :allowClear="false" :disabled="disabled" :value="getValueSting" :changeOnSelect="changeOnSelect" :options="options" :placeholder="placeholder" />
</template>
<script>
import { getAction } from '@/api/manage'

export default {
  name: 'OrgSelect',
  props: {
    orgType: String,
    value: String,
    //是否只查当前用户权限内的行政组织
    userXzzz:{
      type:Boolean,
      default:true
    },
    placeholder: String,
    changeOnSelect:{
      type:Boolean,
      default:false
    },
    category:{
      type:String,
      default:''
    },
    expandTrigger:{
      type:String,
      default:'click'
    },
    getPopupContainer:{
      type: Function,
      default: (node) => node.parentNode
    },
    disabled:{
      type:Boolean,
      default:false
    },
  },

  data() {
    return {
      options: [],
      defaultValue:[]
    };
  },
  created() {
    this.$nextTick(() => {
      this.initAreaData();
    })
  },
  computed: {
      getValueSting(){
        // update-begin author:wangshuai date:20200601 for: 不显示placeholder的文字 ------
        // 当有null或“” placeholder不显示
        if(this.value != null){
          var defaultValueThis = [];
          if(this.options.length>0){
            // for(var i=0;i<=(this.value.length-this.options[0].orgCode.length)/3;i++){
            //   defaultValueThis.push(this.value.substr(0,this.options[0].orgCode.length+(i)*3));
            // }
            for(var i=0;i<=(this.value.length-(this.options[0].value.length))/3;i++){
              if(i==0){
                defaultValueThis.push(this.options[0].value);
              }else{
                defaultValueThis.push(this.options[0].value+""+this.value.substr(this.options[0].value.length,3*i));
              }
            }
          }
          return defaultValueThis;
        }else{
          return undefined;
        }
        // update-end author:wangshuai date:20200601 for: 不显示placeholder的文字 ------
      },
  },
  methods: {
    changeXzc(value) {
      
      var val='';
      if(value.length>0){
        val=value[value.length-1];
      }
      if(this.expandTrigger=='hover'){
        this.defaultValue = val;
      }
      this.value = val;
      this.$emit('input', val);
      this.$emit('change', val);
    },
    initAreaData(){
        this.options = [];
        getAction('/sys/sysDepart/queryTreeList/by/orgType?orgType='+this.orgType+"&userXzzz="+this.userXzzz+"&category="+this.category,{}).then((res)=>{
          let orgList = res.result;
          for(var i = 0;i<orgList.length;i++){
            orgList[i].value = orgList[i].orgCode;
            orgList[i].label = orgList[i].title;
            if(orgList[i].children != null){
              for(var j = 0;j<orgList[i].children.length;j++){
                orgList[i].children[j].value = orgList[i].children[j].orgCode;
                orgList[i].children[j].label = orgList[i].children[j].title;
                if(orgList[i].children[j].children != null){
                  for(var m = 0;m<orgList[i].children[j].children.length;m++){
                    orgList[i].children[j].children[m].value = orgList[i].children[j].children[m].orgCode;
                    orgList[i].children[j].children[m].label = orgList[i].children[j].children[m].title;
                  }
                }
              }
            }
          }
          this.options = orgList;
        })
      },
  },
};
</script>